import axios from "axios";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
import loadConfig from "@Web3WalletConfig/config";
import cookie from "js-cookie";
import { toNano } from "@ton/core";
export default {
  name: "popTask",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", "setting"])
  },
  data() {
    return {
      amount: 500
    };
  },
  watch: {
    "$parent.popDepositShow": {
      async handler(newVal, oldVal) {
        if (newVal) {}
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    async onConfirm() {
      let rs = await this.$http.post("/assets/account/deposit", {
        amount: this.amount,
        symbol: this.$parent.itemData.symbol
      });
      if (rs.code == 0) {
        this.$toasted.success('操作完成');
      }
      this.$parent.popDepositShow = false;
    }
  }
};